import React from 'react';
export default class ArrowIcon extends React.Component {
  render() {
    return (
      <svg viewBox='0 0 38 72' className={this.props.className}>
        <path d="M22 20v24.757l7.88-7.878c1.17-1.173 3.07-1.173 4.24 0 1.173 1.17 1.173 3.07 0 4.24l-13 13c-1.17 1.173-3.07 1.173-4.24 0l-13-13C3.292 40.537 3 39.77 3 39s.293-1.536.88-2.12c1.17-1.173 3.07-1.173 4.24 0L16 44.756V20c0-1.657 1.343-3 3-3s3 1.343 3 3z" />
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PullToRefresh/ArrowIcon.js